export default __webpack_public_path__ + "0b39ead637dd022691169551d3bedf9e.png";